import { userConstants } from "../../constant";
const initialState = { currency: "USD", amount: 1000 };

export function currencyConverter(state = initialState, action) {
  switch (action.type) {
    case userConstants.CONVERT_CURRENCY:
      return {
        currency: action.payload.currency,
        amount: action.payload.amount,
      };

    default:
      return state;
  }
}
